import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration,
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {SpacierArcadeGameAssets} from "./SpacierArcadeGameAssets";
import {SpacierArcade} from "./SpacierArcade";
import {SpacierArcadeGameModuleConfig} from "./SpacierArcadeGameModuleConfig";
import {SpacierArcadeSoundConfig} from "./SpacierArcadeSoundConfig";
import {SpacierArcadeGameMode} from "./gamemode/SpacierArcadeGameMode";

export class SpacierArcadePromoPanelConfig implements PromoPanelGameConfiguration {

    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "SpacierArcade",
            hasActionSpin: true,
            graphics: {backgroundTextureName: SpacierArcadeGameAssets.INTRO_BACKGROUND},
            getParsedData: (response: any, bet: number, prevResponse: any): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    totalSpinWinnings: this.getWin(response, bet, prevResponse),
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank
                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            SpacierArcade.sound.playEffect(SpacierArcadeSoundConfig.instance.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            SpacierArcade.sound.playEffect(SpacierArcadeSoundConfig.instance.AS_WIN_BIG);
        }
    }

    private isBigWin(response: any): boolean {
        const win = this.getWin(response, response.playedBetValue, "");
        const playedBetValue = response.playedBetValue;
        let winRatio: number = Helper.ceilToDecimals((win / playedBetValue), 2);
        if (response.wasFeatureBuy) {
            const betPrice = SpacierArcadeGameModuleConfig.featurePrice.getBuyFeaturePrice(response.playedBetValue, response.wasFeatureBuy);
            winRatio = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        return winRatio >= 15;
    }

    private getWin(response: any, bet: number, prevData: any): number {
        return response.totalSpinWinnings;
    }

    private getFeatureName(response: any): string {
        if (response.nextMode == SpacierArcadeGameMode.FREESPIN_RESPIN || response.mode == SpacierArcadeGameMode.FREESPIN_RESPIN || response.nextMode == SpacierArcadeGameMode.FREESPIN || response.mode == SpacierArcadeGameMode.FREESPIN) {
            return "MILKY WAYS SPINS";
        }
        return "";
    }

    private isFreeSpinTriggered(response: any): boolean {
        return response.freespinTriggeredThisSpin;
    }

    private isRoundComplete(response: any): boolean {
        return [SpacierArcadeGameMode.FREESPIN, SpacierArcadeGameMode.NORMAL].indexOf(response.nextMode) > -1;
    }

    private isBonusEnd(response: any): boolean {
        return response.mode === SpacierArcadeGameMode.FREESPIN && response.nextMode === SpacierArcadeGameMode.NORMAL;
    }

}